namespace $.$$ {

	export class $shm_service_task_menu extends $.$shm_service_task_menu {

		menu_rows() {
			return this.remove_confirmed()
				? [ this.Confirm() ]
				: [
					...( this.pin_enabled() ? [ this.Pin() ] : [] ),
					...( this.archive_enabled() ? [ this.Archive() ] : [] ),
					this.Remove_button(),
				]
		}

		pin_title() {
			return this.pinned() ? 'Открепить' : 'Закрепить'
		}

		archive_title() {
			return this.archived() ? 'Убрать из архива' : 'Архив'
		}

		@ $mol_action
		pin_toggle( next?: Event ) {
			if( next === undefined ) return null
			this.pinned( !this.pinned() )
			this.showed( false )
			return next
		}

		@ $mol_action
		archive_toggle( next?: Event ) {
			if( next === undefined ) return null
			this.archived( !this.archived() )
			this.showed( false )
			return next
		}

	}

}
